module.exports = __webpack_public_path__ + "img/copy.4c0f9ab6.svg";